import { ApolloError, gql, useMutation } from "@apollo/client";
import { EditMainCategoryInput, EditMainCategoryMutation, EditMainCategoryMutationVariables } from "../generated/graphql";

export interface IEditMainCategoryFormProps extends EditMainCategoryInput {}

const EDIT_MAIN_CATEGORY_MUTATION = gql`
  mutation editMainCategory($input: EditMainCategoryInput!) {
    editMainCategory(input: $input) {
      ok
      err
    }
  }
`;

export const useEditMainCategory = (onCompleted?: (data: EditMainCategoryMutation) => void, onError?: (error: ApolloError) => void) => {
  return useMutation<EditMainCategoryMutation, EditMainCategoryMutationVariables>(EDIT_MAIN_CATEGORY_MUTATION, {
    onCompleted,
    onError,
  });
};

